/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { I as InputNumber, d as defineCustomElement$1 } from './input-number.js';

const CalciteInputNumber = InputNumber;
const defineCustomElement = defineCustomElement$1;

export { CalciteInputNumber, defineCustomElement };

//# sourceMappingURL=calcite-input-number.js.map